import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_BOQS = 'GET_BOQS';
export const GET_BOQ = 'GET_BOQ';
export const CREATE_BOQ = 'CREATE_BOQ';
export const UPDATE_BOQ = 'UPDATE_BOQ';
export const DELETE_BOQ = 'DELETE_BOQ';
export const APPROVE_BOQ = 'APPROVE_BOQ';
export const CHECK_BOQ = 'CHECK_BOQ';
export const GET_BOQ_SUMMARY = 'GET_BOQ_SUMMARY';

// Get all BOQs
export const getBOQs = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchBOQs(searchQuery, page, pageSize);
    
    dispatch({ type: GET_BOQS, payload: data });
    return data;
  } catch (error) {
    console.error('Error fetching BOQs:', error);
    throw error;
  }
};

// Get single BOQ
export const getBOQ = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchBOQ(id);
    
    dispatch({ type: GET_BOQ, payload: data });
    return data;
  } catch (error) {
    console.error('Error fetching BOQ:', error);
    throw error;
  }
};

// Create BOQ
export const createBOQ = (boqData, openSnackbar, history, currentLang) => async (dispatch) => {
  try {
    const { data } = await api.createBOQ(boqData);
    
    dispatch({ type: CREATE_BOQ, payload: data });
    openSnackbar('BOQ created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("BOQ created successfully"));
    history.push(`/${currentLang}/app/construction/boq/${data._id}`);
    
    return data;
  } catch (error) {
    console.error('Error creating BOQ:', error);
    openSnackbar('Error creating BOQ', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating BOQ"));
    throw error;
  }
};

// Update BOQ
export const updateBOQ = (id, boqData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateBOQ(id, boqData);
    
    dispatch({ type: UPDATE_BOQ, payload: data });
    openSnackbar('BOQ updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("BOQ updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating BOQ:', error);
    openSnackbar('Error updating BOQ', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating BOQ"));
    throw error;
  }
};

// Delete BOQ
export const deleteBOQ = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteBOQ(id);
    
    dispatch({ type: DELETE_BOQ, payload: id });
    openSnackbar('BOQ deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("BOQ deleted successfully"));
  } catch (error) {
    console.error('Error deleting BOQ:', error);
    openSnackbar('Error deleting BOQ', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting BOQ"));
    throw error;
  }
};

// Approve BOQ
export const approveBOQ = (id, comments, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveBOQ(id, { comments });
    
    dispatch({ type: APPROVE_BOQ, payload: data });
    openSnackbar('BOQ approved successfully', SNACKBAR_DURATION_MS, getSnackbarColor("BOQ approved successfully"));
    
    return data;
  } catch (error) {
    console.error('Error approving BOQ:', error);
    openSnackbar('Error approving BOQ', SNACKBAR_DURATION_MS, getSnackbarColor("Error approving BOQ"));
    throw error;
  }
};

// Check BOQ
export const checkBOQ = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.checkBOQ(id);
    
    dispatch({ type: CHECK_BOQ, payload: data });
    openSnackbar('BOQ checked successfully', SNACKBAR_DURATION_MS, getSnackbarColor("BOQ checked successfully"));
    
    return data;
  } catch (error) {
    console.error('Error checking BOQ:', error);
    openSnackbar('Error checking BOQ', SNACKBAR_DURATION_MS, getSnackbarColor("Error checking BOQ"));
    throw error;
  }
};

// Update BOQ item progress
export const updateItemProgress = (id, sectionIndex, itemIndex, progressData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateBOQItemProgress(id, sectionIndex, itemIndex, progressData);
    
    dispatch({ type: UPDATE_BOQ, payload: data });
    openSnackbar('Item progress updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Item progress updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating item progress:', error);
    openSnackbar('Error updating item progress', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating item progress"));
    throw error;
  }
};

// Get BOQ summary
export const getBOQSummary = (id) => async (dispatch) => {
  try {
    const { data } = await api.getBOQSummary(id);
    
    dispatch({ type: GET_BOQ_SUMMARY, payload: data });
    return data;
  } catch (error) {
    console.error('Error fetching BOQ summary:', error);
    throw error;
  }
};
